import { NgModule } from '@angular/core'
import { UniversityFeatureModule } from './university-feature.module'
import { TrainingUspFeatureModule } from './components/training-usp/training-usp-feature.module'
import { TrainingCategoriesFeatureModule } from './components/training-categories/training-categories-feature.module'
import { TrainingDescriptionFeatureModule } from './components/training-description/training-description-feature.module'
import { TrainingFacetFeatureModule } from './components/training-facet/training-facet-feature.module'
import { TrainingListFeatureModule } from './components/training-list/training-list-feature.module'
import { TrainingHeaderFeatureModule } from './components/training-header/training-header-feature.module'
import { TrainingLocationsFeatureModule } from './components/training-locations/training-locations-feature.module'
import { TrainingObjectivesFeatureModule } from './components/training-objectives/training-objectives-feature.module'
import { TrainingTeaserSliderFeatureModule } from './components/training-teaser-slider/training-teaser-slider-feature.module'

@NgModule({
  imports: [
    UniversityFeatureModule,
    TrainingUspFeatureModule,
    TrainingCategoriesFeatureModule,
    TrainingDescriptionFeatureModule,
    TrainingFacetFeatureModule,
    TrainingListFeatureModule,
    TrainingHeaderFeatureModule,
    TrainingLocationsFeatureModule,
    TrainingObjectivesFeatureModule,
    TrainingTeaserSliderFeatureModule
  ]
})
export class UniversityRootModule {
}
